import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import Main from './Main';
import ErrorPage from './components/Common/Error';
import Calendario from './components/Reservaciones/Calendario';
import Login from './components/Auth/Login';
import Reservaciones from './components/Reservaciones/Reservaciones';
import Dashboard from './components/Dashboard/Dashboard';
//import EstadoCuenta from './components/Titulares/EstadoCuenta';
//import NewEstadoCuenta from './components/Common/test';
import EstadoCuenta from './components/EstadoCuenta/estadoCuenta';
import { Reservar } from './components/Reservaciones/Reservar';
//import { Amenidades } from './components/Amenidades/Amenidades_bak';
import { Amenidades } from './components/Amenidades/Amenidades';
import { LiberarNoches } from './components/Titulares/LiberarNoches';
import FormularioReserva from './components/Reservaciones/FormularioReserva';

import Venta from './components/Link/Venta';
import Temporadas from './components/Admin/Temporadas';

//Rutas
import CrearSocio from './components/Admin/Socios/CrearSocio'; //admin
import MostrarPostventas from './components/Admin/Postventas/MostrarPostVentas'; //admin
import HistorialPagosPost from './components/PostVenta/HistorialPagos/HistorialPagosPost'; //postventa
import AgregarPagos from './components/PostVenta/Pagos/AgregarPagos'; //postventa

//Rutas multi usuario-> usadas por admin, titulares, postventas.
import RutaReporteVentas from './components/RutasMultiUsuario/ReporteVentas/Reporte'; //admin-postventa
import Socios from './components/RutasMultiUsuario/VerSocios/Socios'; //admin-postventa
import ManejarReservaciones from './components/RutasMultiUsuario/ManejoReservaciones/ManejarReservaciones';
import { Fragment } from 'react';
import { useSelector } from 'react-redux';
import GeneralErrorPage from './util/generalErrorPage';
import { FinanceManagement } from './components/financeManagement/financeManagement';
import NuevoEditarTitular from './components/Rutas/Titular/NuevoEditarTitular';
import ReservasSocio from './components/Admin/Socios/TablaSociosAdmin/reservasSocio';
import CambiarContrasena from './components/Auth/cambiarContraseña';
import MembresiaMain from './components/Admin/MembresiaMain';

import './i18n';
import MembershipStatus from './components/EstadoCuenta/MembershipStatus';
import { AmenidadesBak } from './components/Amenidades/Amenidades_bak';
import { AmenidadesMain } from './components/Amenidades/AmenidadesMain';


const router = createBrowserRouter([
  {
    path: '/',
    element: <Main />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: '/calendario',
        element: <Calendario />,
      },
      {
        path: '/reservar-ahora',
        element: <FormularioReserva />,
      },
      {
        path: '/reservaciones',
        element: <Reservaciones />,
      },
      {
        path: '/manejar-reservaciones/:reservacionId',
        element: <ManejarReservaciones />,
      },
      {
        path: '/socios',
        element: <Socios />,
      },
      {
        path: '/resumen',
        element: <Dashboard />,
      },
      {
        path: '/crear-usuario',
        element: <CrearSocio />,
      },
      {
        path: '/titular/:titularId',
        element: <NuevoEditarTitular />,
      },
      {
        path: '/estado-cuenta',
        element: <EstadoCuenta />,
      },
      {
        path: '/reporte-ventas/:titularId',
        element: <RutaReporteVentas />,
      },
      {
        path: '/reservar',
        element: <Reservar />,
      },
      {
        path: '/liberar-noches',
        element: <LiberarNoches />,
      },
      // {
      //   path: '/day-pass',
      //   element: <Amenidades />,
      // },
      {
        path: '/day-pass',
        element: <AmenidadesMain />,
      },
      {
        path: '/pagos/:titularId',
        element: <AgregarPagos />,
      },
      {
        path: '/historial-pagos/:titularId',
        element: <HistorialPagosPost />,
      },
      {
        path: '/membresias',
        element: <MembresiaMain />,
      },
      {
        path: '/temporadas',
        element: <Temporadas />,
      },
      {
        path: '/postventas',
        element: <MostrarPostventas />,
      },
      {
        path: '/cuenta',
        element: <EstadoCuenta />,
      },
      {
        path: '/finanzas',
        element: <FinanceManagement />,
      },
      {
        path: '/reservas-socio/:idSocio',
        element: <ReservasSocio />,
      },
      {
        path: '/membresia/:id',
        element: <MembershipStatus />,
      }
    ],
  },
  {
    path: 'login',
    element: <Login />,
  },
  {
    path: '/password-reset/:code',
    element: <CambiarContrasena/>
  },
  {
    path: '/venta/:codigo',
    element: <Venta />,
  },
]);
function App() {
  const unable = useSelector((state) => state.reservatioUnable)
  return(
    <Fragment>
    {
      unable ? 
        <GeneralErrorPage/>
        :
        <RouterProvider router={router} />
    }
    </Fragment>
  ) 
}

export default App;
